export const SERVICE_ID = "service_t58p8ee";
export const TEMPLATE_ID = "testing_mail_dev_109";
export const PUBLIC_KEY = "z6K_mMGa7ahjIUbyC";
export const MAP_KEY = "AIzaSyCJH2lf4z5GD1cRZgW9UvGT6G-1PrenwzI";
